export enum ThemeName {
  ITAPTEC = "itaptec",
  DARK = "dark",
  CUSTOM = "custom",
  LIQUID_GLASS = "liquidGlass",
}

export const THEME_LABELS: Record<ThemeName, string> = {
  [ThemeName.ITAPTEC]: "Itaptec",
  [ThemeName.DARK]: "Modo oscuro",
  [ThemeName.CUSTOM]: "Custom",
  [ThemeName.LIQUID_GLASS]: "Liquid Glass",
};

export function getAvailableThemeOptions(): Array<{ value: ThemeName; label: string }> {
  return Object.values(ThemeName).map((name) => ({
    value: name as ThemeName,
    label: THEME_LABELS[name as ThemeName],
  }));
}
export function isValidThemeName(value: string | unknown): value is ThemeName {
  return Object.values(ThemeName).includes(value as ThemeName);
}

export function parseThemeName(value: string | unknown, fallback: ThemeName = ThemeName.ITAPTEC): ThemeName {
  if (isValidThemeName(value)) {
    return value;
  }
  console.warn(`[Theme] Tema inválido: "${value}". Usando: "${fallback}"`);
  return fallback;
}














